var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#081132",
    d: "M8.698 5.406c.512-.541 1.343-.541 1.856 0 .512.542.512 1.42 0 1.961L7.48 10.613h15.207c.683 0 1.243.55 1.307 1.254L24 12c0 .766-.588 1.387-1.313 1.387L7.48 13.386l3.074 3.247c.478.505.51 1.304.095 1.848l-.095.113c-.513.541-1.344.541-1.856 0L3.384 12.98c-.512-.541-.512-1.419 0-1.96l5.314-5.614z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.9c4110f1.svg";
export { ForwardRef as ReactComponent };